import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { RouterModule, Routes } from '@angular/router';
import { SharedModule } from '../_shared/shared.module';
import { FilterPopoverComponent } from '../_shared/components/filter-popover/filter-popover.component';

import { GenerateTokenComponent } from './generate-token.component';
import { TranslateModule } from '@ngx-translate/core';

const routes: Routes = [
  {
    path: '',
    component: GenerateTokenComponent,
    title: 'Generate Partner Token'
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    IonicModule,
    RouterModule.forChild(routes),
    SharedModule,
    FilterPopoverComponent,
    TranslateModule
  ],
  declarations: [GenerateTokenComponent],
  exports: [GenerateTokenComponent]
})
export class GenerateTokenModule { } 
